import { Divider } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import './ErrorLine.scss';

export interface IErrorLineProps {
  className?: string | object;
}

function ErrorLine({ className }: IErrorLineProps) {
  return <Divider className={classNames('error-line', className)} />;
}

export default ErrorLine;
